import {useDvFlag, useDvFlagAccess} from "./featureFlag";
import flagService from "./featureFlag/flagService.js";
import Utils from '@/services/utils'

export function getNavbarBottomLinks() {
  const links = [
    {
      label: "navigation.roadmap",
      to: "/redirect/roadmap",
      icon: "i-material-symbols-lightbulb",
    },
    {
      label: "navigation.news",
      to: "news",
      icon: "i-material-symbols-newspaper",
      onlyForTheme: "default",
    },
    {
      label: "navigation.account",
      icon: "i-material-symbols-person",
      children: [
        {
          label: "navigation.certificate",
          to: useDvFlagAccess("beepiz-certificate-can:read") ? "certificate" : "certificate_denied",
        },
        {
          label: "navigation.offers",
          to: useDvFlagAccess("beepiz-plan-bpz-can:read") ? "offers" : "offers_denied",
          onlyForTheme: "default",
        },
        {
          label: "navigation.formation",
          to: Utils.t("navigation.formation_tutos_link"),
          onlyForTheme: "default",
          target: '_blank'
        },
        // {
        //     label: "navigation.formation_sfr",
        //     to: Utils.t("navigation.formation_tutos_link_sfr"),
        //     onlyForTheme: "sfr",
        //     target: '_blank'
        // },
        {
          label: "navigation.formation",
          to: Utils.t("navigation.formation_tutos_link"),
          onlyForTheme: "catsafe",
          target: '_blank'
        },
        {
          label: "navigation.me",
          to: "me",
        },
        {
          label: "navigation.logout",
          to: "/redirect/logout",
        },
      ],
    },
  ];

  try {
    const flag = useDvFlag("beepiz-beebot-can:read");
    if (flagService.flags !== null && (flag.access || !!flag.fallback)) {
      links.unshift({
        label: "navigation.beebot",
        to: "/redirect/beebot",
        onlyForTheme: "default",
        labelClass:
          "bg-gradient-to-r from-[#F56A00] from-0% to-[#F8AA00] to-65% bg-clip-text text-transparent",
        avatar: {
          src: "https://cloudfront.beepiz.com/common/other/beebot.png",
          alt: "beebot-logo",
        },
        badge: flag.status ? String(flag.status).charAt(0).toUpperCase() + String(flag.status).slice(1) : undefined,
      });
    }
  } catch (error) {
    console.log(error);
  }

  return links;
}

export function getReactiveBottomNavbarLinks() {
  return getNavbarBottomLinks();
}
